<template>
    <div style="padding: 40px;">
      <div style="margin-left: 250px">
        <p>&nbsp;</p>
        <p style="font-size: 63px;">admin</p>
        <p>&nbsp;</p>
        <p style="font-size: 21px;">欢迎使用桃花汽车导购管理平台</p>
        <p>&nbsp;</p>
        <p v-html="currentTime" style="font-size: 21px;"></p>
      </div>
    </div>
</template>

<script>
export default {
  name: "welcome",
  data () {
    return {
      currentTime: ''
    }
  },
  mounted() {
    this.timer = setInterval(() => {
      this.getCurrentTime();
    }, 1000)
  },
  methods: {
    getCurrentTime() {
      let result = '';
      let currentDate = new Date();
      result += currentDate.getFullYear() + '年'
        + currentDate.getMonth() + '月'
        + currentDate.getDay() + '日' + ' '
        + currentDate.getHours() + ':'
        + currentDate.getMinutes() + ':'
      + currentDate.getSeconds();
      this.currentTime = result;
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/index/welcome.vue